import React, { useState } from 'react';
import './Navbar.css';
import logo from '../assets/images/logo.png';

const Navbar = ({ onOpenModal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <div className="navbar-brand">
          <div className="logo-container">
            <img src={logo} alt="ZeroInfezioni" className="logo" />
            <div className="brand-text">
              <span className="brand-name">ZeroInfezioni</span>
              <span className="tagline">Servizi di cybersicurezza</span>
            </div>
          </div>
        </div>
        
        <div className="navbar-right">
          <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
            <a href="#caratteristiche" className="navbar-item" onClick={() => setIsMenuOpen(false)}>Caratteristiche</a>
            <a href="#piani" className="navbar-item" onClick={() => setIsMenuOpen(false)}>Piani</a>
            <a href="#protezione" className="navbar-item" onClick={() => setIsMenuOpen(false)}>Protezione</a>
            <a href="#contatti" className="navbar-item" onClick={() => setIsMenuOpen(false)}>Contatti</a>
            <div className="navbar-actions-mobile">
              <button className="btn btn-primary" onClick={onOpenModal}>
                Scarica Gratis
              </button>
            </div>
          </div>
          
          <div className="navbar-actions">
            <button className="btn btn-primary" onClick={onOpenModal}>
              Scarica Gratis
            </button>
          </div>
        </div>
        
        <button 
          className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Apri menu di navigazione"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar; 